import React from 'react';
import { Flex, Spinner } from '@applyboard/crystal-ui';
import { useFeatureDecision } from '@applyboard/ui-utils';
import { FeatureFlag } from '../../../FeatureFlags';
import GicLandingPage from '../../../pages/GicLandingPage/GicLandingPage';

/**
 * A wrapper to the gic landing page & forms. Should only be used when you want the GIC submissions to be anonymous/public.
 * No authenticated api call should happen on its children components.
 */
const PublicGicLandingPage: React.FC = () => {
  const [decisionEngine, decisionEngineReady] = useFeatureDecision();

  const isVasRbcGicExtendedCountriesEnabled =
    decisionEngine?.isFeatureEnabled(FeatureFlag.VasRbcGicExtendedCountries) ?? false;

  if (!decisionEngineReady) {
    return (
      <Flex align="center" justify="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <GicLandingPage isVasRbcGicExtendedCountriesEnabled={isVasRbcGicExtendedCountriesEnabled} />
  );
};

export default PublicGicLandingPage;
